<template>
    <div>
        <!---------------------------------------------------------------- 扫码 功能 ----------------------------------->
        <div class="qr-div">
          <h3>查询鉴定</h3>
          <div class="qr-div-body">
            <div class="qr-left">
              <div>
                
              </div>
              <button class="sweep">
                <input type="file" @change="upload($event)" />验证二维码
              </button>
              <div class="imgurl">
                <img :src="imgurl" alt="当前识别的二维码" />
              </div>
            </div>
            <div class="qr-right">
              <h2>查询结果</h2>
              <ul>
                <li><a>朝代：</a><span>当代</span></li>
                <li><a>钱币名称：</a><span>贰分铝币</span></li>
                <li><a>版别和其他描：</a><span>坯饼</span></li>
                <li><a>分数：</a><span>MS62</span></li>
                <li><a>尺寸：</a><span>直径21.0mm 重1.1g</span></li>
                <li><a>代码和其他标：</a><span>China</span></li>
                <li><a>鉴定机构：</a><span>金盾评级</span></li>
                <li><a>图片展示：</a>
                  <div class="imgurl">
                      <img :src="imgurl2" alt="当前识别的二维码" />
                  </div></li>
              </ul>
              <canvas class="canvas" ref="canvas"></canvas>
            </div>


          </div>
          
          <!-- <button class="sweep">
            <input type="file" @change="upload($event)" />验证二维码
          </button>
          <div class="imgurl">
            <img :src="imgurl" alt="当前识别的二维码" />
            <img :src="imgurl2" alt="当前识别的二维码" />
          </div> -->


          <!-- <textarea
              class="result"
              cols="76"
              rows="6"
              v-model="result"
              placeholder="二维码识别结果！"
          ></textarea> -->

          <!-- <canvas class="canvas" ref="canvas"></canvas> -->
        </div>
    </div>
</template>

<script>
import jsQR from "jsqr"
import Jimp from "jimp"
import QRCode from "qrcode";

export default {
    name: "upload",
    data() {
        return {
            //二维码
            timer: null,
            result: "(结果)",
            imgurl: "",
            imgurl2: "",
            isAnimation: true,
            audio: Object,
            video: Object,
            cvsele: Object,
            canvas: Object,

        }
    },
    mounted() {

        this.audio = new Audio("../assets/tone.mp3");
        this.video = document.createElement("video");
        this.cvsele = this.$refs.canvas;
        this.canvas = this.cvsele.getContext("2d");
    },
    methods: {
        //Tage
        handleClick (tab, event) {
            console.log(event.uid)
        },

        //二维码
        cance() {
            this.isAnimation = false;
            cancelAnimationFrame(this.timer);
            setTimeout(() => {
                this.cvsele.style.display = "none";
            }, 1000);
        },

        upload(e) {

            this.cance();
            const file = e.target.files[0];
            const createObjectURL = window.createObjectURL ||  window.URL.createObjectURL || window.webkitURL.createObjectUR;
            this.result = "";
            this.imgurl = createObjectURL(file);

            const fReader = new FileReader();
            fReader.readAsDataURL(file);          // Base64 8Bit字节码
            // fReader.readAsBinaryString(file);  // Binary 原始二进制
            // fReader.readAsArrayBuffer(file);   // ArrayBuffer 文件流
            fReader.onload = (e) => {
                this.imgurl2 = e.target.result;
                e.target.result && Jimp.read(e.target.result).then(async (res) => {
                    const { data, width, height } = res.bitmap;
                    try {
                        const resolve = await jsQR(data, width, height);
                        this.result = resolve.data;
                    } catch (err) {
                        this.result = "识别失败，请检查二维码是否正确！";
                    } finally {
                        //console.info("读取到的文件：", res);
                    }
                }).catch((err) => {
                    console.error("文件读取错误：", err);
                });
            };
        },
    },
    

   
};
</script>

<style lang="scss" scoped>

.qr-div {
  width: 1400px;
  margin: 0 auto;
  margin-top: 20px;
  h3 {
    font-size: 24px;
    text-align: left;
    margin: 20px 96px;
    padding: 10px 0;
    border-bottom: 1px solid #DFDFDF;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      left: 48px;
      bottom: -1px;
      width: 100px;
      height: 2px;
      margin-left: -50px;
      background-color: #409EFF;
    }
  }

  .qr-div-body {
    display: flex;

    .qr-left {
      width: 50%;
      margin: auto 0;
      .imgurl {
        img {
          width: 280px;
          height: 260px;
        }
      }
    }
    .qr-right {
      border-left: 1px solid #DFDFDF;
      width: 45%;
      padding: 30px;
      h2 {
          width: 300px;
          margin-bottom: 20px;
        }
      ul {
        width: 300px;
        li {
          list-style: none;
          padding: 10px;
          text-align: left;
          border-bottom: 1px solid #DFDFDF;
          display: flex;

          &:nth-last-child(1) {
            display: block;
            border-bottom: 0;

            .imgurl {
              margin: 0;
              padding: 0;
              img {
                margin: 0;
                padding-bottom: 0;
                border: 0;
              }
            }
          }
        }
        a {
          color: #8B8B8B;
          width: 35%;
        }
        
      }
    }

  }
    
}
  
  
.sweep {
position: relative;
margin: 10px;
padding: 10px;
width: 180px;
font-size: 14px;
cursor: pointer;
color: white;
background: #409EFF;
border: 1px solid #409EFF;
overflow: hidden;
    input {
        position: absolute;
        font-size: 100px;
        opacity: 0;
    }
}


.imgurl {
margin: 20px;
text-align: center;
img {
    margin: 20px;
    padding: 10px;
    border: 1px solid gray;
    border-radius: 8px;
    // width: 280px;
    // height: 260px;
    width: 170px;
    height: 150px;
}
}
.result {
box-sizing: border-box;
padding: 10px;
border: 1px solid gray;
border-radius: 8px;
font-size: 16px;
}
.canvas {
display: none;
box-sizing: border-box;
position: fixed;
top: 0;
right: 0;
bottom: 0;
left: 0;
width: 100vw;
height: 100vh;
}
</style>
